import { CommonModule, JsonPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbCalendar, NgbDateParserFormatter, NgbDatepicker, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-select-work-orderfor-reduction',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepicker, DataTablesModule, JsonPipe],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './select-work-orderfor-reduction.component.html',
  styleUrl: './select-work-orderfor-reduction.component.scss'
})
export class SelectWorkOrderforReductionComponent {
  @Input() Id: number = 0;
  isDisabled: boolean = false
  DesignationLoad: any[] = [];
  Shift: any[] = [];
  DutyLoad: any[] = [];
  SiteLoad: any[] = [];
  Designation: string = '';
  DesignationId: number = 0;
  ShiftTitle: string = '';
  ShiftID: number = 0;
  DutyId: number = 0;
  Duty: string = '';
  SiteId: number = 0;
  SiteName: string = '';
  dtTrigger: Subject<any> = new Subject<any>();
  WorkOrderNumber: string = '';
  WorkOrderTable: any[] = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private comboload: ComboService,
    private toast: ToastService,
    public activeModal: NgbActiveModal,
    private siteadditionreduction: AdditionOfManpowerService,
    private dateFormate: CustomDateParserFormatter,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SiteId = this.Id;
    this.ComboLoad('Site');
    this.ComboLoad('Designation');
    this.ComboLoad('shift');
  }

  onSelectChange(type: string) {
    if (type === 'Designation') {
      const selected = this.DesignationLoad.find(designation => designation.DesignationMasterID === this.DesignationId);
      this.Designation = selected ? selected.DesignationName : null;
      this.DutyId = 0
      this.Duty = ''
    }
    else if (type === 'Shift') {
      const selected = this.Shift.find(shift => shift.ShiftMasterID === this.ShiftID);
      this.ShiftTitle = selected ? selected.ShiftTitle : null;
    }
    else if (type === 'Duty') {
      const selected = this.DutyLoad.find(duty => duty.DutyMasterID === this.DutyId);
      this.Duty = selected ? selected.DutyName : null;
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.DesignationId = 0
      this.Designation = ''
      this.DutyId = 0
      this.Duty = ''
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.Id : 0,
      'DesignationId': (Combotype == 'Duty') ? this.DesignationId : 0,
      'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        } else if (Combotype == 'Designation') {
          this.DesignationLoad = response.ComboLoad;
        } else if (Combotype == 'Duty') {
          this.DutyLoad = response.ComboLoad;
        }
        else if (Combotype == 'shift') {
          this.Shift = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  Load() {
    const data = {
      SelectType: 'D',
      ESS_ShiftWiseManpowerMasterId: 0,
      ESS_ShiftWiseManpowerDetailsId: 0,
      AllocationType: 'R',
      WoNo: this.WorkOrderNumber,
      SiteId: this.SiteId,
      DesignationId: this.DesignationId,
      DutyId: this.DutyId,
      ShiftId: this.ShiftID
    }

    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.WorkOrderTable = Object.values(data.Table);
          this.WorkOrderTable.forEach(shift => {
            shift.FromDate = '';
            shift.NoOfPerson = ''
          });
          this.isDisabled = false;
        }
        else {
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
          this.isDisabled = false;
          this.WorkOrderTable = [];
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }
  Cancel() {
    this.activeModal.close();
  }

  Ok() {
    let isValid = true;
    let hasErrors = false;
    const validData = [];
    for (let shift of this.WorkOrderTable) {
      const hasValidReduction = shift.hasOwnProperty('NoOfPerson') && shift.NoOfPerson > 0;
      const hasValidFromDate = shift.FromDate;
      if ((hasValidReduction && !hasValidFromDate) || (!hasValidReduction && hasValidFromDate)) {
        isValid = false;
        hasErrors = true;
        this.toast.show({
          message: `Both Reduction and FromDate are required for ${shift.DesignationName}`,
          type: toastTypeEnum.warning
        });
        break;
      }
      if (hasValidReduction && hasValidFromDate) {
        if (shift.NoOfPerson > shift.Balance) {
          isValid = false;
          hasErrors = true;
          this.toast.show({
            message: `Reduction of ${shift.NoOfPerson} manpower cannot exceed Balance of ${shift.Balance} for ${shift.DesignationName}`,
            type: toastTypeEnum.warning
          });
          break;
        }
        const redate = new Date(this.dateFormate.format(shift.FromDate));
        const addition = new Date(shift.AdditionDate);
        if (redate < addition) {
          isValid = false;
          hasErrors = true;
          this.toast.show({
            message: `Reduction Date Cannot be lesser than Addition Date for Designation ${shift.DesignationName}`,
            type: toastTypeEnum.warning
          });
          break;
        }
        validData.push(shift);
      }
    }
    if (!hasErrors && validData.length > 0) {
      for (let shift of validData) {
        shift.FromDate = this.dateFormate.format(shift.FromDate);
      }
      this.activeModal.close(validData);
    } else if (!hasErrors && validData.length === 0) {
      this.activeModal.close();
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57 || input.value.length >= 7) {
      event.preventDefault();
    }
  }
}
